import { useState } from 'react';
import { Eye, EyeOff } from 'react-feather';

function passwordStrength(password: string) {
  if (!password) return 0;

  // award every unique letter until 5 repetitions
  const letters = password
    .split('')
    .reduce(
      (dictionary, letter) => ({ ...dictionary, [letter]: (dictionary[letter] ?? 0) + 1 }),
      {} as Record<string, number>
    );
  const lettersScore = Object.entries(letters)
    .map(([letter, occurrences]) => Math.min(occurrences, 5) * 3)
    .reduce((a, b) => a + b, 0);

  // bonus points for mixing it up
  const variations = {
    digits: /\d/,
    lower: /[a-z]/,
    upper: /[A-Z]/,
    nonWords: /\W/
  };
  const variationCount = Object.entries(variations)
    .map<number>(([key, regex]) => (regex.test(password) ? 1 : 0))
    .reduce((a, b) => a + b, 0);
  const variationScore = (variationCount - 1) * 10;

  return lettersScore + variationScore;
}

const MIN_PASSWORD_STRENGTH = 40;

const Password: React.FC<
  React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> & {
    isNew: boolean;
  }
> = ({ isNew, ...props }) => {
  const [visible, setVisible] = useState(false);
  return (
    <div className='password-wrapper'>
      <input
        type={visible ? 'text' : 'password'}
        {...props}
        onChange={
          isNew
            ? e => {
                if (passwordStrength(e.target.value) < MIN_PASSWORD_STRENGTH && e.target.value.length > 0) {
                  e.target.classList.add('weak');
                } else {
                  e.target.classList.remove('weak');
                }
                // eslint-disable-next-line react/destructuring-assignment
                return props.onChange?.(e);
              }
            : props.onChange
        }
      />
      <button className='eye' onClick={() => setVisible(v => !v)} type='button'>
        {visible ? <Eye size={18} /> : <EyeOff size={18} />}
      </button>
      <style jsx>{`
        .password-wrapper {
          position: relative;
          height: 2.5rem;
        }
        .password-wrapper input {
          width: 100%;
        }
        .eye {
          position: absolute;
          right: 8px;
          top: 50%;
          transform: translateY(-50%);
        }
      `}</style>
    </div>
  );
};

export default Password;
